import './Avatar.css';
const avatarImg = require('../../images/avatar.png');
export const Avatar = () => {
    return (
        <div className="avatar">
            <img src={avatarImg} alt="" className="avatar__img" />
        </div>
    );
};
